module.exports = __webpack_public_path__ + "img/gt.e654bb4.svg";